import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-downArrow",
  "use": "icon-downArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-downArrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 1024L819.2 512l-614.4 0L512 1024zM614.4 0l-204.8 0L409.6 512 614.4 512 614.4 0z\" p-id=\"43370\" fill=\"#1afa29\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/downArrow.svg
// module id = MCxY
// module chunks = 212